import type { RouteKey } from '../state/router.js';
import type { ComponentType } from 'react';
import { Experience } from './Experience.js';
import { History } from './History.js';
import { Viral } from './Viral.js';
import { Storyboard } from './Storyboard.js';
import { VideoGen } from './VideoGen.js';
import { Replace } from './Replace.js';
import { Assets } from './Assets.js';
import { Settings } from './Settings.js';

export const ROUTE_TITLES: Record<RouteKey, string> = {
  experience: '首页',
  history: '任务管理',
  viral: '爆款拆解',
  storyboard: '分镜脚本',
  video: '视频生成',
  object: '物体替换',
  scene: '场景替换',
  person: '人物替换',
  assets: '资源库',
  settings: '设置',
};

export const ROUTE_VIEWS: Record<RouteKey, ComponentType> = {
  experience: Experience,
  history: History,
  viral: Viral,
  storyboard: Storyboard,
  video: VideoGen,
  object: Replace,
  scene: Replace,
  person: Replace,
  assets: Assets,
  settings: Settings,
};
